import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import humanTime from 'flarum/common/helpers/humanTime';
import LogInModal from 'flarum/forum/components/LogInModal';
import { showGiveaway, enterGiveaway, drawGiveaway, deleteGiveaway, claimGiveaway } from '../../common/api';
import { countdown } from '../../common/format';
import GiveawayFormModal from '../components/GiveawayFormModal';
export default class GiveawayPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "entering", false);
    _defineProperty(this, "claiming", false);
    _defineProperty(this, "giveaway", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  load() {
    const slug = m.route.param('slug');
    this.loading = true;
    showGiveaway(slug).then(res => {
      this.giveaway = res.data;
      app.setTitle(this.giveaway.title);
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  enter() {
    const g = this.giveaway;
    if (!app.session.user) {
      app.modal.show(LogInModal);
      return;
    }
    this.entering = true;
    enterGiveaway(g.id).then(res => {
      this.giveaway = res.data;
      this.entering = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ernestdefoe-giveaways.forum.enter_success'));
      m.redraw();
    }).catch(() => {
      this.entering = false;
      m.redraw();
    });
  }
  draw() {
    const g = this.giveaway;
    if (!confirm(app.translator.trans('ernestdefoe-giveaways.forum.confirm_draw'))) return;
    drawGiveaway(g.id).then(res => {
      this.giveaway = res.data;
      m.redraw();
    });
  }
  claim() {
    const g = this.giveaway;
    this.claiming = true;
    claimGiveaway(g.id).then(res => {
      this.giveaway = res.data;
      this.claiming = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ernestdefoe-giveaways.forum.claim_success'));
      m.redraw();
    }).catch(() => {
      this.claiming = false;
      m.redraw();
    });
  }
  edit() {
    app.modal.show(GiveawayFormModal, {
      giveaway: this.giveaway,
      onsave: () => this.load()
    });
  }
  remove() {
    const g = this.giveaway;
    if (!confirm(app.translator.trans('ernestdefoe-giveaways.forum.confirm_delete'))) return;
    deleteGiveaway(g.id).then(() => m.route.set(app.route('giveaways.index')));
  }
  view() {
    if (this.loading) return m("div", {
      className: "GiveawayPage"
    }, m(LoadingIndicator, null));
    const g = this.giveaway;
    if (!g) {
      return m("div", {
        className: "GiveawayPage container"
      }, m("p", null, app.translator.trans('ernestdefoe-giveaways.forum.empty')));
    }
    return m("div", {
      className: "GiveawayPage"
    }, m("div", {
      className: 'GiveawayPage-hero' + (g.coverUrl ? '' : ' GiveawayPage-hero--plain'),
      style: g.coverUrl ? {
        backgroundImage: "url(\"".concat(g.coverUrl, "\")")
      } : undefined
    }, m("div", {
      className: "GiveawayPage-hero-overlay"
    }, m("div", {
      className: "container"
    }, m(Link, {
      className: "GiveawayPage-back",
      href: app.route('giveaways.index')
    }, m(Icon, {
      name: "fas fa-chevron-left"
    }), ' ', app.translator.trans('ernestdefoe-giveaways.forum.nav')), m("span", {
      className: "GiveawayCard-status GiveawayCard-status--".concat(g.status)
    }, app.translator.trans("ernestdefoe-giveaways.forum.status_".concat(g.status))), g.category && m("span", {
      className: "GiveawayPage-category",
      style: {
        backgroundColor: g.category.color
      }
    }, g.category.icon && m(Icon, {
      name: g.category.icon
    }), " ", g.category.name), m("h1", {
      className: "GiveawayPage-title"
    }, g.title), m("div", {
      className: "GiveawayPage-prize"
    }, m(Icon, {
      name: "fas fa-trophy"
    }), " ", g.prize)))), m("div", {
      className: "container GiveawayPage-content"
    }, m("div", {
      className: "GiveawayPage-main"
    }, this.winnerBanner(g), this.descriptionBlock(g), this.requirementsBlock(g), this.winnersBlock(g), this.fairnessBlock(g)), m("aside", {
      className: "GiveawayPage-side"
    }, this.actionBox(g), g.canManage && this.manageBox(g))));
  }
  winnerBanner(g) {
    if (!g.iWon) return null;
    const claimed = !!g.myClaimedAt;
    return m("section", {
      className: "GiveawayPage-winnerBanner"
    }, m("div", {
      className: "GiveawayPage-winnerBanner-head"
    }, m(Icon, {
      name: "fas fa-trophy"
    }), m("h2", null, app.translator.trans('ernestdefoe-giveaways.forum.you_won'))), m("p", null, app.translator.trans('ernestdefoe-giveaways.forum.you_won_sub', {
      prize: g.prize
    })), claimed ? m("div", {
      className: "GiveawayPage-claimed"
    }, m(Icon, {
      name: "fas fa-check-circle"
    }), " ", app.translator.trans('ernestdefoe-giveaways.forum.claimed')) : m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-box-open",
      loading: this.claiming,
      onclick: () => this.claim()
    }, app.translator.trans('ernestdefoe-giveaways.forum.claim')), claimed && g.claimInstructions ? m("div", {
      className: "GiveawayPage-claimInstructions"
    }, m("h4", null, app.translator.trans('ernestdefoe-giveaways.forum.claim_next_steps')), g.claimInstructions.split('\n').map(l => l.trim() ? m("p", null, l) : null)) : null);
  }
  descriptionBlock(g) {
    if (!g.description) return null;
    return m("section", {
      className: "GiveawayPage-section"
    }, m("h2", null, app.translator.trans('ernestdefoe-giveaways.forum.description_label')), m("div", {
      className: "GiveawayPage-description"
    }, g.description.split('\n').map(line => line.trim() ? m("p", null, line) : null)));
  }
  requirementsBlock(g) {
    const reqs = [];
    if (g.minPosts > 0) reqs.push(m("li", null, m(Icon, {
      name: "fas fa-comment"
    }), " ", app.translator.trans('ernestdefoe-giveaways.forum.req_min_posts', {
      count: g.minPosts
    })));
    if (g.minAgeDays > 0) reqs.push(m("li", null, m(Icon, {
      name: "fas fa-hourglass-half"
    }), " ", app.translator.trans('ernestdefoe-giveaways.forum.req_min_age', {
      count: g.minAgeDays
    })));
    return m("section", {
      className: "GiveawayPage-section"
    }, m("h2", null, app.translator.trans('ernestdefoe-giveaways.forum.requirements_label')), m("ul", {
      className: "GiveawayPage-reqs"
    }, reqs.length ? reqs : m("li", null, m(Icon, {
      name: "fas fa-check"
    }), " ", app.translator.trans('ernestdefoe-giveaways.forum.no_requirements'))));
  }
  winnersBlock(g) {
    if (g.status !== 'drawn') return null;
    const winners = g.winners || [];
    return m("section", {
      className: "GiveawayPage-section"
    }, m("h2", null, app.translator.trans('ernestdefoe-giveaways.forum.winners_label')), winners.length === 0 ? m("p", null, app.translator.trans('ernestdefoe-giveaways.forum.no_winners')) : m("ul", {
      className: "GiveawayPage-winners"
    }, winners.map(w => m("li", {
      className: "GiveawayPage-winner"
    }, m("span", {
      className: "GiveawayPage-winner-pos"
    }, "#", w.position), w.user ? m(Link, {
      href: app.route('user', {
        username: w.user.username
      }),
      className: "GiveawayPage-winner-user"
    }, m("img", {
      className: "Avatar",
      src: w.user.avatarUrl || '',
      alt: ""
    }), m("span", null, w.user.displayName)) : m("span", {
      className: "GiveawayPage-winner-user"
    }, "\u2014"), m("span", {
      className: 'GiveawayPage-winner-claim' + (w.claimedAt ? ' is-claimed' : '')
    }, m(Icon, {
      name: w.claimedAt ? 'fas fa-check-circle' : 'far fa-clock'
    }), ' ', w.claimedAt ? app.translator.trans('ernestdefoe-giveaways.forum.claimed') : app.translator.trans('ernestdefoe-giveaways.forum.unclaimed'))))));
  }
  fairnessBlock(g) {
    if (g.status !== 'drawn' || !g.drawSeed) return null;
    return m("section", {
      className: "GiveawayPage-section GiveawayPage-fairness"
    }, m("h2", null, m(Icon, {
      name: "fas fa-shield-alt"
    }), " ", app.translator.trans('ernestdefoe-giveaways.forum.fairness_label')), m("p", null, app.translator.trans('ernestdefoe-giveaways.forum.fairness_intro')), m("div", {
      className: "GiveawayPage-fairnessField"
    }, m("label", null, app.translator.trans('ernestdefoe-giveaways.forum.seed_label')), m("code", null, g.drawSeed)), m("div", {
      className: "GiveawayPage-fairnessField"
    }, m("label", null, app.translator.trans('ernestdefoe-giveaways.forum.hash_label')), m("code", null, g.entrantHash)), m("p", {
      className: "GiveawayPage-fairnessHelp helpText"
    }, app.translator.trans('ernestdefoe-giveaways.forum.fairness_help')));
  }
  actionBox(g) {
    const active = g.status === 'active';
    const entered = g.myEntries > 0;
    return m("div", {
      className: "GiveawayPage-actionBox"
    }, m("div", {
      className: "GiveawayPage-stat"
    }, m("strong", null, g.entrantCount), m("span", null, app.translator.trans('ernestdefoe-giveaways.forum.entrants', {
      count: g.entrantCount
    }))), active ? m("div", {
      className: "GiveawayPage-countdown"
    }, m(Icon, {
      name: "fas fa-clock"
    }), ' ', app.translator.trans('ernestdefoe-giveaways.forum.ends_in', {
      time: countdown(g.endsAt)
    })) : m("div", {
      className: "GiveawayPage-countdown"
    }, app.translator.trans('ernestdefoe-giveaways.forum.ended'), g.drawnAt ? [' · ', humanTime(g.drawnAt)] : null), active && (entered ? m("div", {
      className: "GiveawayPage-entered"
    }, m(Icon, {
      name: "fas fa-check-circle"
    }), ' ', app.translator.trans('ernestdefoe-giveaways.forum.your_entries', {
      count: g.myEntries
    })) : !app.session.user ? m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.enter()
    }, app.translator.trans('ernestdefoe-giveaways.forum.login_to_enter')) : m(Button, {
      className: "Button Button--primary Button--block",
      icon: "fas fa-ticket-alt",
      loading: this.entering,
      onclick: () => this.enter()
    }, app.translator.trans('ernestdefoe-giveaways.forum.enter'))), active && entered && g.postBonus > 0 && this.earnMore(g));
  }
  earnMore(g) {
    const sources = g.mySources || {};
    const got = !!sources['post'];
    return m("div", {
      className: "GiveawayPage-earn"
    }, m("h4", null, app.translator.trans('ernestdefoe-giveaways.forum.earn_more')), m("div", {
      className: 'GiveawayPage-earnItem' + (got ? ' is-done' : '')
    }, m(Icon, {
      name: got ? 'fas fa-check-circle' : 'far fa-circle'
    }), got ? app.translator.trans('ernestdefoe-giveaways.forum.earned_post', {
      count: g.postBonus
    }) : app.translator.trans('ernestdefoe-giveaways.forum.earn_post', {
      count: g.postBonus
    })));
  }
  manageBox(g) {
    return m("div", {
      className: "GiveawayPage-manage"
    }, m(Button, {
      className: "Button Button--block",
      icon: "fas fa-pencil-alt",
      onclick: () => this.edit()
    }, app.translator.trans('ernestdefoe-giveaways.forum.edit')), g.status === 'active' && m(Button, {
      className: "Button Button--block",
      icon: "fas fa-dice",
      onclick: () => this.draw()
    }, app.translator.trans('ernestdefoe-giveaways.forum.draw_now')), m(Button, {
      className: "Button Button--block GiveawayPage-delete",
      icon: "fas fa-trash",
      onclick: () => this.remove()
    }, app.translator.trans('ernestdefoe-giveaways.forum.delete')));
  }
}
flarum.reg.add('ernestdefoe-giveaways', 'forum/pages/GiveawayPage', GiveawayPage);